import { pushGTMAnalyticsEvent } from "../../../modules/pushGTMAnalyticsEvent";
import "./styles.scss";

export const AxysLevelTabs = ({ tabs, itemsStateObj }) => {
  // Find the active Axys level
  const getActiveAxysLevel = () => {
    if (itemsStateObj.state.activeIds.accessories.array.length === 0) {
      return null;
    }
    return itemsStateObj.state.activeIds.accessories.array.find((item) => item._id.includes("axys_level"));
  };

  const activeAxysLevel = getActiveAxysLevel();

  const handleClick = (tab) => {
    // Don't do anything if this tab is already active
    if (activeAxysLevel && activeAxysLevel._id === tab._id) {
      return;
    }

    // Create a copy of the current state
    const copyActiveIds = { ...itemsStateObj.state.activeIds };

    // First, remove any existing Axys level items and their accessories
    const axysLevelIndex = copyActiveIds.accessories.array.findIndex((item) => item._id.includes("axys_level"));
    if (axysLevelIndex !== -1) {
      // Get the current Axys level object
      const currentAxysLevelId = copyActiveIds.accessories.array[axysLevelIndex]._id;
      const currentAxysLevelObj = itemsStateObj.state.array.find((item) => item._id === currentAxysLevelId);

      // Remove the Axys level item itself
      copyActiveIds.accessories.array.splice(axysLevelIndex, 1);

      // Remove all accessories that are part of the current Axys level package
      if (currentAxysLevelObj?.includedAccessories) {
        // Filter out accessories that are part of the Axys level package
        copyActiveIds.accessories.array = copyActiveIds.accessories.array.filter((item) => !currentAxysLevelObj.includedAccessories.includes(item._id));
      }
    }

    // Get the full item object for the selected Axys level tab
    const selectedAxysLevelObj = itemsStateObj.state.array.find((item) => item._id === tab._id);
    if (!selectedAxysLevelObj) {
      console.error(`Axys level with ID ${tab._id} not found in items array`);
      return;
    }

    // Then add the selected Axys level item (only the ID)
    copyActiveIds.accessories.array.push({
      _id: tab._id,
    });

    // Add all accessories from the Axys level to the state with only their IDs
    if (selectedAxysLevelObj?.includedAccessories && selectedAxysLevelObj.includedAccessories.length > 0) {
      selectedAxysLevelObj.includedAccessories.forEach((accessoryId) => {
        // Find the full item object for the accessory to access its metadata
        const accessoryObj = itemsStateObj.state.array.find((item) => item._id === accessoryId);

        if (!accessoryObj) {
          console.error(`Accessory with ID ${accessoryId} not found in items array`);
          return;
        }

        // Ensure the accessory has proper metadata to display in 3D model
        if (!accessoryObj.metaData) {
          accessoryObj.metaData = {};
        }

        // Set special flags for included accessories to ensure they load in 3D model
        accessoryObj.metaData.isAxysIncluded = true;
        accessoryObj.metaData.is3dModelDynamicallyInjected = true;

        // Check if accessory is already in the array before adding
        if (!copyActiveIds.accessories.array.some((item) => item._id === accessoryId)) {
          copyActiveIds.accessories.array.push({
            _id: accessoryId,
          });
        }
      });
    }

    // Update the state
    itemsStateObj.setState(copyActiveIds);

    // Track the event
    pushGTMAnalyticsEvent({
      event: "Tab Click - MojoDesk",
      tab: tab.displayName,
      page: "accessories",
    });
  };

  const tabElements = tabs.map((tab) => {
    // Check if this tab is active
    const isActive = activeAxysLevel?._id === tab._id;

    // Shorten the display text to just "Level X" for Axys levels
    let displayText = tab.displayName;
    if (displayText.includes("AXYS Level")) {
      displayText = displayText.replace("AXYS Level", "Level");
    }

    return (
      <div key={tab._id} className={`tab text-center ${isActive ? "active" : ""}`} onClick={() => handleClick(tab)}>
        <p className="mb-0 py-1">{displayText}</p>
      </div>
    );
  });

  return <div className="TabsContainer AxysLevelTabsContainer d-flex mx-auto justify-content-stretch align-items-center">{tabElements}</div>;
};
